import { render, staticRenderFns } from "./AreaMessagesTable.vue?vue&type=template&id=a442aab8&scoped=true"
import script from "./AreaMessagesTable.vue?vue&type=script&lang=js"
export * from "./AreaMessagesTable.vue?vue&type=script&lang=js"
import style0 from "./AreaMessagesTable.vue?vue&type=style&index=0&id=a442aab8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a442aab8",
  null
  
)

export default component.exports